module.exports = __webpack_public_path__ + "img/conasi_logo.d61a221f.png";